import React, { useState, useEffect } from 'react'
import { axiosCreateEvolutionSignup } from '../../actions/authActions'
import ReactLoading from 'react-loading'
import classnames from 'classnames'

const EventEnquirySignup = (props) => {
  const [formData, setFormData] = useState({
    FullName: '',
    VenueName: '',
    Email: '',
    Mobile: '',
    Position: '',
  })
  const [isLoading, toggleLoading] = useState(false)

  const updateFormData = (name, value) => {
    setFormData((prevState) => {
      let newState = {
        ...prevState,
        [name]: value,
      }
      return newState
    })
  }

  const handleFieldUpdate = (e) => {
    e.preventDefault()
    e.stopPropagation()

    updateFormData(e.target.name, e.target.value)
  }

  const handleFormSubmit = (e) => {
    e.preventDefault()
    e.stopPropagation()

    let valid = true
    Object.keys(formData).forEach((field) => {
      if (!formData[field]) {
        valid &= false
      }
    })

    if (!valid) return

    toggleLoading(true)

    return axiosCreateEvolutionSignup(formData)
      .then((response) => {
        if (response.status === 200) {
          window.location.href = '/'
        }
      })
      .catch((error) => {
        console.log(error)
        // handleAxiosErrors(error)
      })
      .finally(() => {
        toggleLoading(false)
      })
  }

  console.log('inside comp')
  return (
    <form onSubmit={handleFormSubmit} noValidate={true} class="form signup-form pb-3">
      <label class="field" data-label="Full Name *">
        <span class="field__text">Full Name *</span>
        <input onChange={handleFieldUpdate} type="text" name="FullName" class="field__input" required></input>
      </label>
      <label class="field" data-label="Venue Name *">
        <span class="field__text">Venue Name *</span>
        <input onChange={handleFieldUpdate} type="text" name="VenueName" class="field__input" required></input>
      </label>
      <label class="field" data-label="Position/Title *">
        <span class="field__text">Position/Title *</span>
        <input onChange={handleFieldUpdate} type="text" name="Position" class="field__input" required></input>
      </label>
      <label class="field" data-label="Email *">
        <span class="field__text">Email *</span>
        <input onChange={handleFieldUpdate} type="email" name="Email" class="field__input" required></input>
      </label>
      <label class="field" data-label="Phone Number *">
        <span class="field__text">Phone Number *</span>
        <input onChange={handleFieldUpdate} type="tel" name="Mobile" class="field__input" required></input>
      </label>

      <button
        type="submit"
        className={classnames('button button--alone button--main', isLoading && 'button--loading')}
        title="Submit"
      >
        <span style={{ opacity: isLoading ? 0 : 1 }}>Submit</span>
        {isLoading === true && (
          <ReactLoading className="button__spinner" type="spin" color="white" height={25} width={25} />
        )}
      </button>
    </form>
  )
}
// default props
EventEnquirySignup.defaultProps = {}
// validate props
EventEnquirySignup.propTypes = {}

export default EventEnquirySignup
